module.exports = __webpack_public_path__ + "cf6cf29ed1fb821fd3669de1e19f9585.svg";